import { h } from 'preact';
import { useState } from 'preact/hooks';
import { translateError } from '../../i18n.js';
import Card from './Card.jsx';
import Button from './Button.jsx';

// Instellingen › Gegevens exporteren: all of the club's data in one ZIP (voorwaarden art. 8)

const ERRORS = {
  export_in_progress: 'Er wordt al een export gemaakt. Probeer het over een minuut opnieuw.',
};

export default function ClubExportCard() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  async function download() {
    setBusy(true);
    setError('');
    setDone(false);
    try {
      const res = await fetch('/api/club-export', { credentials: 'include' });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw Object.assign(new Error(data.error), { code: data.error || 'server_error' });
      }
      const name = /filename="([^"]+)"/.exec(res.headers.get('content-disposition') || '')?.[1] || 'vereniging4u-export.zip';
      const url = URL.createObjectURL(await res.blob());
      const a = document.createElement('a');
      a.href = url;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 10000);
      setDone(true);
    } catch (err) {
      setError(ERRORS[err.code] || translateError(err.code));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Card title="Gegevens exporteren" style="margin-top:24px">
      <p class="text-sm" style="margin:0 0 8px">
        Download alle gegevens van de club in één ZIP-bestand: een Excel-bestand met een tabblad per onderdeel
        (leden, taken, agenda, vergaderingen, besluiten, VOG's en meer) en alle geüploade bestanden.
      </p>
      <p class="text-sm text-muted" style="margin:0 0 12px">
        De export bevat persoonsgegevens van alle leden, ook VOG's en certificaten. Bewaar hem veilig.
        De andere beheerders krijgen een melding en de export komt in de auditlog.
      </p>
      {error && <div class="alert alert-error mb-3">{error}</div>}
      {done && <div class="alert alert-success mb-3">De export is gedownload.</div>}
      <Button onClick={download} disabled={busy}>{busy ? 'Export wordt gemaakt…' : 'Alles exporteren'}</Button>
    </Card>
  );
}
